const fonts = {
  body: 'Inter, sans-serif',
  heading: 'Inter, sans-serif',
  mono: 'Inter, sans-serif',
}

export default fonts
